import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import { Link } from "./../util/router";
import "./HeroSection4.scss";

function HeroSection4(props) {
  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container margin-responsive">
        <div className="columns is-vcentered is-desktop">
          <div className="column has-text-centered logo-animation-margin">
            <img src={props.image} alt="Illustration" />
          </div>
          <div className="column is-1" />
          <div className="column is-6-desktop has-text-centered-touch">
            <SectionHeader
              title={props.title}
              subtitle={props.subtitle}
              size={1}
              spaced={true}
            />
            <div className="buttons is-inline-flex">
              <Link
                to={props.buttonPath}
                className={
                  "button is-medium" +
                  (props.buttonColor ? ` is-${props.buttonColor}` : "") +
                  (props.buttonInverted ? " is-inverted" : "")
                }
              >
                {props.buttonText}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}

export default HeroSection4;

